<template>
  <div class="control-group"
       :class="{
         'invalid': input_invalids && input_invalids[input_name],
          'disabled': input_disabled
       }">
    <div class="control" :class="{'required': input_required}">
      <label :for="input_id">
        {{ Language.say(label_text) }}
      </label>
      <span class="select-wrapper">
        <select
          :id="input_id"
          :value="input_value"
          :disabled="input_disabled"
          @input="onInputValue"
          @change="onChangeValue"
        >
          <option v-for="(option, index) in normalized_options"
                  :key="'i_s_' + index"
                  :value="option.value || null">
            {{ tag_text ? Language.say(`${tag_text}${option.label}`) : option.label }}
          </option>
        </select>
      </span>
      <p class="error" v-if="input_invalids && input_invalids[input_name]">
        {{ Language.say(error_text) }}
      </p>
    </div>
  </div>
</template>

<script setup>
  import { defineProps, defineEmits, ref, onBeforeMount } from 'vue';
  import Language from '@/js/Shared/Language/Language';

  const props = defineProps({
    input_id: {
      type: String,
      default: '',
    },
    input_name: {
      type: String,
      required: true,
    },
    input_required: {
      type: Boolean,
      default: false
    },
    input_invalids: {
      type: Object,
      default : () => ({}),
    },
    input_value: {
      type: String,
      default: ''
    },
    input_disabled: {
      type: Boolean,
      default: false,
    },
    label_text: {
      type: String,
      default: ''
    },
    error_text: {
      type: String,
      default: 'global.forms.invalid.input'
    },
    tag_text: {
      type: String,
      default: ''
    },
    options: {
      type: [Array, Object],
      required: true,
    },
  });

  const emit = defineEmits(['change', 'update:input_value']);

  const normalized_options = ref([]);

  onBeforeMount(() => {
    normalized_options.value = normalizedOptions();
  });

  const onChangeValue = ($event) => {
    emit('change', $event.target.value);
  }

  const onInputValue = ($event) => {
    emit('update:input_value', $event.target.value);
  }

  const normalizedOptions = () => {
    const options = Array.isArray(props.options) ? props.options : Object.entries(props.options);

    return options.reduce((acc, option) => {
      if (typeof option === 'string') {
        acc.push({ value: option, label: option });
      } else if (Array.isArray(option)) {
        acc.push({ value: option[1], label: option[0] });
      } else {
        acc.push(option);
      }
      return acc;
    }, []);
  }
</script>
